const middleware = {}

middleware['services'] = require('../middleware/services.js')
middleware['services'] = middleware['services'].default || middleware['services']

export default middleware
